import {Grid, Paper} from "@material-ui/core";
import backgroundTwo from "../../../images/INQBAY_HP_2.png";
import {Podcast} from "../../../components/Podcast";
import React from "react";
import useStyles from "../../../components/useStyles";
import {Link} from "react-router-dom";

const BaseModule = (
    {
        podcastImage,
        podcastSound,
    }
) => {
    const classes = useStyles();

    return <Grid item xs={12} md={12}>
        <Paper className={classes.paper_left} style={{
            backgroundImage: "url(" + backgroundTwo + ")",
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat'
        }}>
            <br/>
            <Grid container spacing={0} item xs={12} md={12}>
                <Grid xs={12} sm={6} className={classes.paper_big}>
                    <br/>
                    <h3 className={classes.whiteText}>Poslechněte si, jak prakticky postupovat</h3>
                    <img src={podcastImage} alt={'Podcast banner'} className={classes.mainIMG}/><br/>
                    <Podcast sound={podcastSound}/>
                    <br/>
                </Grid>
                <Grid xs={12} sm={6} className={classes.paper_small}>
                    <Grid className={classes.paper_center}>
                        <br/>
                        <Link to={'quiz/1'}>
                            <button className={"btn btn--primary--solid--long2"}>
                                <Grid className={classes.paper}>
                                    <a className={classes.blackText}>
                                        Vyzkoušejte si
                                    </a>
                                </Grid>
                            </button>
                        </Link>
                    </Grid>
                    <Grid className={classes.paper_center}>
                        <br/>
                        <Link to={'pdf'}>
                            <button className={"btn btn--primary--solid--long2"}>
                                <Grid className={classes.paper}>
                                    <a className={classes.blackText}>Jak to tedy je?</a>
                                </Grid>
                            </button>
                        </Link>
                    </Grid>
                </Grid>
            </Grid>
        </Paper>
    </Grid>
};

export default BaseModule;
